/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon16Solid = forwardRef('ArrowFigureACircleUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 11.516a.75.75 0 0 1-.75-.75V6.15L5.608 7.994a.75.75 0 0 1-1.12-.998L6.693 4.52a1.75 1.75 0 0 1 2.614 0l2.205 2.476a.75.75 0 1 1-1.12.998L8.75 6.15v5.616a.75.75 0 0 1-.75.75Z" })));
});
